<template>
  <div id="app">
    <router-view class="main" />
  </div>
</template>
<script>
import Vue from "vue";
import api from "./api/api";
export default {
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {},
};
</script>

<style lang="less">
@import url(./assets/css/base.less);
html,
body,
#app {
  height: 100%;
}
</style>
